// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CKsTn","toggle":"styles_toggle__2zpfq","preview":"styles_preview__3uI-h"};